<template>
  <div class="hd_bar">
    <div class="hd_ic">
      <span class="ic-degreeProgram"></span>
    </div>
    <div class="hd_txt">
      <span class="title_txt" id="programGuideTitle">{{programGuide.title}}</span>
    </div>

    <template v-if="programGuide && programGuide.uuid && !isTempUser && isBookmarkEnabled">
      <span v-if="isBookmarked(programGuide)" @click.stop.prevent="deleteProgramGuideBookmark(programGuide)" class="ic_bm_container bookmarked hd_txt" title="remove this program from bookmark">
        <span class="ic8-bookmark3"></span>
      </span>
      <span v-else @click.stop.prevent="bookmarkProgramGuide(programGuide)" class="ic_bm_container hd_txt" title="bookmark this program">
        <span class="ic8-bookmark3"></span>
      </span>
    </template>

    <b-popover ref="programGuideTitlePopup" target="programGuideTitle" triggers="click" placement="top" class="title_popup" container="programGuideTitleContainer">
      <div class="title_container">
        {{ programGuide.title }}
      </div>
      <div class="ic_container">
        <span class="ic ic-close" v-on:click="closeProgramGuideTitlePopup"></span>
      </div>
    </b-popover>
    <div id="programGuideTitleContainer" class="title_container_popup"></div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'program-guide-title',
    props: ['programGuide'],
    computed: {
      ...mapState({
        'userObj': state => state.login.userObj,
        'isTempUser': state => state.login.tempUser,
        'bookmarks': state => state.explore.bookmarks
      })
    },
    async mounted () {
      await this.loadAllBookmarks()
    },
    methods: {
      ...mapActions([
        'loadAllBookmarks',
        'loadCreateBookmarks',
        'loadDeleteBookmark'
      ]),
      closeProgramGuideTitlePopup () {
        this.$refs.programGuideTitlePopup.$emit('close')
      },
      getBookmark (programGuide) {
        let target = _.find(this.bookmarks, (bookmark) => {
          return (bookmark.entityUuid === programGuide.uuid)
        })
        return target
      },
      isBookmarked (programGuide) {
        programGuide.bookmark = this.getBookmark(programGuide)
        return programGuide.bookmark && programGuide.bookmark.uuid
      },
      async bookmarkProgramGuide (programGuide) {
        const bookmark = {
          source: 'explore',
          entityType: 'programguide',
          entityTitle: programGuide.title,
          entityUuid: programGuide.uuid,
          institutionId: programGuide.institutionId,
          userId: this.userObj.uuid
        }
        const response = await this.loadCreateBookmarks(bookmark)
        const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + programGuide.title + '\''
        const notify = response ? this.notifySuccess : this.notifyFailure
        notify(message)
        await this.loadAllBookmarks()
      },
      async deleteProgramGuideBookmark (programGuide) {
        await this.loadDeleteBookmark(programGuide.bookmark.uuid)
        this.notifySuccess('Successfully deleted bookmark \'' + programGuide.title + '\'')
        await this.loadAllBookmarks()
      },
      notifySuccess (text) {
        return this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        return this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideTitle.vue